export const mailLinks = () => {
    const els = document.querySelectorAll('.mail-link')

    els.forEach(el => {
        el.addEventListener('click', e => {
            window.location = `mailto:${decode(e.currentTarget.dataset.value)}`
        })
    })
}

const decode = (s) => {
    const s1 = s.replaceAll(':', '@').replaceAll('|', '.')

    return decodeROT13(s1)
}

// const encode = (s) => {
//    const s1 = s.replaceAll('@', ':').replaceAll('.', '|')
//    return decodeROT13(s1)
// }

const decodeROT13 = (s) => {
    return s.replace(/[a-zA-Z]/g, function (c) {
        return String.fromCharCode((c <= 'Z' ? 90 : 122) >= (c = c.charCodeAt(0) + 13) ? c : c - 26)
    })
}
